import { FETCH_THROUGHPUT_REPORT_RES } from '../actions/types';

const throughputReportReducer = (state = [], action) => {
  switch (action.type) {
    case FETCH_THROUGHPUT_REPORT_RES:
      return action.payload;
    default:
      return state;
  }
};

export default throughputReportReducer;
